import { Component, OnInit, ViewEncapsulation, Input, HostListener } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../shared';
import { PartnerNamesEnum } from '../medizinisches-cannabisantrag/shared';

const copeiaEmail = "info@copeia.de";


@Component({
    selector: 'app-doc-check-login',
    templateUrl: "./doc-check-login.component.html",
    styleUrls: ["./doc-check-login.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DocCheckLoginComponent implements OnInit {
    @Input() partnerName: string = "";
    partnerObj: any = null;
    partnerEmail: string = copeiaEmail;
    PartnerNamesEnum = PartnerNamesEnum;

    showLoading: boolean = false;
    inputPassword: string = "";
    loginError: boolean = false;

    DocCheckLoginType: 'login_xl' | 'login_l' | 'login_m' | 'login_s' = "login_xl";
    DocCheckLoginCode: string = "";
    DocCheckLoginLogName: string = "";
    DocCheckLoginCodePartner: string = "";
    get DocCheckLoginUrl() {
        if (this.DocCheckLoginCodePartner && this.DocCheckLoginCodePartner.length) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(`https://login.doccheck.com/code/de/${this.DocCheckLoginCodePartner}/${this.DocCheckLoginType}/`);
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(`https://login.doccheck.com/code/de/${this.DocCheckLoginCode}/${this.DocCheckLoginType}/`);
    }

    get DocCheckWidth() {
        return this.DocCheckLoginType === 'login_xl' ? 467 :
            this.DocCheckLoginType === 'login_l' ? 424 :
                this.DocCheckLoginType === 'login_m' ? 311 :
                    156;
    }

    get DocCheckHeight() {
        return this.DocCheckLoginType === 'login_xl' ? 231 :
            this.DocCheckLoginType === 'login_l' ? 215 :
                this.DocCheckLoginType === 'login_m' ? 188 :
                    203;
    }

    get fullYear() {
        return new Date().getFullYear();
    }

    constructor(private sharedService: SharedService,
        private sanitizer: DomSanitizer) {
        this.getAPIConfig();
    }

    getAPIConfig() {
        this.sharedService.getAPIConfig().subscribe(
            res => {
                this.DocCheckLoginCode = res.DocCheckLoginCode;
                this.DocCheckLoginLogName = res.DocCheckLoginLogName;
            }
        );
    }

    saveDocCheckLoginLogName(name) {
        if (name) {
            this.sharedService.saveDocCheckLoginLogName(name).subscribe();
        }
    }

    ngOnInit(): void {
        this.onWindowResize();
        this.getPartnerConfig();
        this.fnCheckOnPageLoad();
    }

    getPartnerConfig() {
        this.sharedService.getPartnerConfig().subscribe(res => {
            if (res) {
                let partnerObj = res[this.partnerName];
                if (partnerObj) {
                    this.partnerObj = partnerObj;
                    this.partnerEmail = partnerObj["Email"] || copeiaEmail;
                    this.DocCheckLoginCodePartner = partnerObj["DocCheckLoginCode"] || "";
                    this.saveDocCheckLoginLogName(partnerObj["DocCheckLoginLogName"]);
                } else {
                    this.partnerObj = null;
                    this.partnerEmail = copeiaEmail;
                    this.saveDocCheckLoginLogName(this.DocCheckLoginLogName);
                }
            }
        }, err => {
            this.partnerObj = null;
            this.partnerEmail = copeiaEmail;
            this.saveDocCheckLoginLogName(this.DocCheckLoginLogName);
        })
    }

    fnCheckOnPageLoad() {
        const queries = this.sharedService.getUrlVars();
        const dc = queries["dc"];
        const dc_timestamp = queries["dc_timestamp"];
        if (dc && dc_timestamp) {
            let actionType = `${this.partnerName}`;
            let textPayload = `doc check login successfully`;
            this.sharedService.fnLogActivity(actionType, textPayload).subscribe();
            this.fnContinueToForm();
        } else {
            let actionType = `${this.partnerName}`;
            let textPayload = `doc check login page`;
            this.sharedService.fnLogActivity(actionType, textPayload).subscribe();
        }
    }

    fnValidatePassword() {
        this.showLoading = true;
        this.loginError = false;
        const hashPassword = this.sharedService.convertToHash(this.inputPassword);
        this.sharedService.getProtectedPassword().subscribe(
            res => {
                if (res.AntragPassword === hashPassword) {
                    this.fnContinueToForm();
                } else {
                    this.fnShowLoginError();
                }
            },
            err => {
                this.fnShowLoginError();
            }
        )
    }

    errorTimer: any;
    async fnShowLoginError() {
        this.showLoading = false;
        this.loginError = true;
        clearTimeout(this.errorTimer);
        this.errorTimer = setTimeout(() => {
            this.loginError = false;
        }, 5000);

    }


    fnContinueToForm() {
        this.showLoading = false;
    }


    @HostListener('window:resize', ['$event'])
    onWindowResize(event = null) {
        if (window.innerWidth < 320) {
            this.DocCheckLoginType = 'login_s';
        } else if (window.innerWidth < 500) {
            this.DocCheckLoginType = 'login_m';
        } else if (window.innerWidth < 600) {
            this.DocCheckLoginType = 'login_l';
        } else {
            this.DocCheckLoginType = 'login_xl';
        }
    }
}
